import purchaseOrderAPI from '@/services/API/purchase-order'
import purchaseOrderProcessAPI from '@/services/API/purchase-order-process'
import purchaseReceiveAPI from '@/services/API/purchase-receive'
import moment from 'moment';
//WARNING => DUPLCATED IN purcahseOrdersEditor
let actionsMap = {
  save: {
    associatedStatus: 'DRAFT'
  },
  receive: {
    associatedStatus: 'RECEIVED'
  },
  receivePartiel: {
    associatedStatus: 'PARTIAL_RECEIVED'
  },
  bill: {
    associatedStatus: 'BILLS'
  },
  cancel : {
    associatedStatus: 'CANCELLED'
  },
  set_in_correction : {
    associatedStatus: 'IN_CORRECTION'
  }
};
/**
 * Get the status of the sales order depending on the action executed.
 * The worklfow is:
 * NONE -> draft -> confirmed -> (invoiced | packed | shipped) -> fullfiled -> closed
 * @param {String} action
 * @param {Object} salesOrderStatuses
 * @param {Object} salesOrder
 */
function getStatusFromAction(action, purchaseOrderStatuses, purchaseOrder) {
  const saveStatus = purchaseOrder.status==null?purchaseOrderStatuses.find(s => s.code === 'DRAFT') : purchaseOrder.status;
  return action==='save' ? saveStatus : purchaseOrderStatuses.find(s => s.code === actionsMap[action].associatedStatus);
}

const invalidatePurchaseOrdersList = function ({ commit }) {
  commit('SET_PAGE',1);
  commit('INVALIDATE_LIST');
}

const initPurchaseOrders = function ({commit, dispatch}, {inventoryId}){
  dispatch('invalidatePurchaseOrdersList');
  commit('SET_INVENTORY_ID', inventoryId);
  commit('SET_PAGE',1);

  //Ajout des statuts custom
  if(localStorage.PURCHASE_ORDER_CUSTOM_STATUS!=null){
    _.forEach(JSON.parse(localStorage.PURCHASE_ORDER_CUSTOM_STATUS), customStatus=>{
      actionsMap[customStatus.action]=customStatus.actionsMap[customStatus.action];
    })
  }
}

function buildSearchAndFiltersParams(state){
  let params ={};
  params.orderBy = state.orderBy.orderName;
  params.direction = state.orderBy.direction;
  params.searchTerms = state.searchTerms;
  params.limit = state.limit;
  params.page = state.page;
  params.inventoryId=state.inventoryId;

  params.status = state.filters.status?state.filters.status:undefined;
  params.startDate = state.filters.date?moment(state.filters.date[0]).format("YYYY-MM-DD"):undefined;
  params.endDate = state.filters.date?moment(state.filters.date[1]).format("YYYY-MM-DD"):undefined;

  params.availabilityStartDate = state.filters.availabilityDate?moment(state.filters.availabilityDate[0]).format("YYYY-MM-DD"):undefined;
  params.availabilityEndDate = state.filters.availabilityDate?moment(state.filters.availabilityDate[1]).format("YYYY-MM-DD"):undefined;

  params.year = state.filters.year ? moment(state.filters.year).format("YYYY") : undefined;
  params.availabilityYear = state.filters.availabilityYear ? moment(state.filters.availabilityYear).format("YYYY") : undefined;

 return params;
}

const fetchNextPurchaseOrdersPage = function({commit, dispatch, state}){

  commit('SET_PAGE',state.page+1);

  let params = buildSearchAndFiltersParams(state);

  commit('SET_LOADING', true);
  return purchaseOrderAPI.fetchPurchaseOrders(params).then(purchaseOrders => {
    if(purchaseOrders.count!=null){
      commit('UPDATE_PURCHASE_ORDERS', purchaseOrders.list);
      commit('SET_COUNT', purchaseOrders.count );
      commit('SET_PAGES', purchaseOrders.pages );
    }


    commit('SET_LOADING', false);
  });
}

const fetchSearchedPurchaseOrders = function({ commit , state}, query) {
  if(state.outDated){
    commit('SET_LOADING', true);
    let params = buildSearchAndFiltersParams(state);

    return purchaseOrderAPI.fetchPurchaseOrders(params)
      .then(purchaseOrders=>{
        commit('SET_PURCHASE_ORDERS', purchaseOrders.list);
        if(purchaseOrders.count){
          commit('SET_COUNT', purchaseOrders.count );
          commit('SET_PAGES', purchaseOrders.pages );
          commit('SET_PAGE', purchaseOrders.page);
        }
        commit('SET_LOADING', false);
      })
  }
};

const setOrderBy = function ({commit,dispatch}, orderBy){
  commit('SET_ORDER_BY', orderBy);
  dispatch('invalidatePurchaseOrdersList');
  dispatch('fetchSearchedPurchaseOrders');
}
const setSortIcon = function ({commit,dispatch}, sortIcon){
  commit('SET_SORT_ICON', sortIcon);
  dispatch('invalidatePurchaseOrdersList');
  dispatch('fetchSearchedPurchaseOrders');
}
let searchTimeOut = null;
const setSearchTerms = function ({commit, dispatch}, searchTerms){
  commit('SET_SEARCH_TERMS', searchTerms);
  commit('SET_LOADING', true);
  clearTimeout(searchTimeOut)
  searchTimeOut = setTimeout(() => {
    dispatch('invalidatePurchaseOrdersList')
    dispatch('fetchSearchedPurchaseOrders');
  }, 300)
}
const changePage = function ({commit, dispatch}, page){
  commit('SET_PAGE', page);
  dispatch('invalidatePurchaseOrdersList');
  dispatch('fetchSearchedPurchaseOrders');
}

const setSelectedPurchaseOrder = function({commit, state, dispatch}, {index, selectedPurchaseOrder, products, productItems}){
  if(index!=null){
    commit('SET_SELECTED_INDEX', index);
    commit('SET_LOADING_SELECTED_PURCHASE_ORDER', true);

    purchaseOrderProcessAPI.getPurchaseOrder(state.purchaseOrders[index].id)
      .then(results=>{
        commit('SET_SELECTED_PURCHASE_ORDER', results.purchaseOrder);
        commit('SET_SELECTED_PURCHASE_ORDER_PRODUCTS', results.products);
        commit('SET_SELECTED_PURCHASE_ORDER_PRODUCT_ITEMS', results.productItems);
        commit('SET_SELECTED_PURCHASE_ORDER', results.purchaseOrder);
        commit('SET_LOADING_SELECTED_PURCHASE_ORDER', false);
        dispatch('buildHistoricActivities', results.purchaseOrder.status_logs);
      })
  }
  else{
    commit('SET_SELECTED_PURCHASE_ORDER', selectedPurchaseOrder);
    commit('SET_SELECTED_PURCHASE_ORDER_PRODUCTS', products);
    commit('SET_SELECTED_PURCHASE_ORDER_PRODUCT_ITEMS', productItems);
    dispatch('buildHistoricActivities', selectedPurchaseOrder.status_logs);
  }

}

const refreshSelectedPurchaseOrder = function({commit, state, dispatch}) {
  const selectedId = state.selectedIndex != null ? state.purchaseOrders[state.selectedIndex].id : state.selectedPurchaseOrder.id;
  // console.log("Refrech selectedId : ", selectedId);
  if (selectedId != null) {
    commit('SET_LOADING_SELECTED_PURCHASE_ORDER', true);
    return purchaseOrderAPI.getPurchaseOrder(selectedId)
      .then((purchaseOrder) => {
        commit('SET_SELECTED_PURCHASE_ORDER', purchaseOrder);
        commit('SET_LOADING_SELECTED_PURCHASE_ORDER', false);
        dispatch('buildHistoricActivities', purchaseOrder.status_logs);
      })
  }


}

const setLoadingSelectedPurchaseOrder = function({commit}, loading) {
  commit('SET_LOADING_SELECTED_PURCHASE_ORDER', loading);
}

const putSelectedPurchaseOrder = function({commit, state, rootState, dispatch}, action){

  // if(state.selectedPurchaseOrder.status.code!='IN_CORRECTION'){
    let status = getStatusFromAction(action, rootState.statuses.purchaseOrderStatuses,state.selectedPurchaseOrder);
    let purchaseToUpdate = _.cloneDeep(state.selectedPurchaseOrder);
    purchaseToUpdate.status = status;
    return purchaseOrderAPI.putPurchaseOrder(purchaseToUpdate)
      .then(purchaseOrderUpdated=>{
        dispatch('updateSelectedPurchaseOrder', purchaseOrderUpdated);
        dispatch('buildHistoricActivities', purchaseOrderUpdated.status_logs);
        dispatch('stockItems/invalidateStockItems',null,{root:true});
      })
  // }
}

const deleteSelectedPurchaseOrder = function ({commit, state, dispatch}){
  return purchaseOrderAPI.deletePurchaseOrder(state.selectedPurchaseOrder.id)
    .then(()=>{
      commit('INVALIDATE_LIST');
      dispatch('fetchSearchedPurchaseOrders');
    })
}
const invalidAndUpdateSelectedPurchaseOrder = function ({dispatch, state}){
  purchaseOrderAPI.getPurchaseOrder(state.selectedPurchaseOrder.id)
    .then(purchaseOrder=>{
      dispatch('updateSelectedPurchaseOrder',purchaseOrder);
      dispatch('buildHistoricActivities');
    })
}

const updateSelectedPurchaseOrder = function ({commit}, purchaseOrderUpdated){
  commit('ASSIGN_SELECTED_PURCHASE_ORDER', purchaseOrderUpdated);
}


const setItemInCorrection = function({commit,state, dispatch}, {index, in_correction}){
  commit('SET_ITEM_IN_CORRECTION', {index, in_correction});
  let in_correction_status = false;
  _.forEach(state.selectedPurchaseOrder.lines, line=>{
    if(line.in_correction)in_correction_status=true;
  })
  if(in_correction_status){
    dispatch('putSelectedPurchaseOrder','set_in_correction')
  }else{
    //Nous ne sommes plus en correctino alors trouvons le bon statut à metttre : CONFIRMED ou PARTIAL_RECEIVED
    let partial_receive = false;
    _.forEach(state.selectedPurchaseOrder.lines, line=>{
      if(line.purchase_status.qty_received>0)partial_receive=true
    })
    if(partial_receive){

      dispatch('putSelectedPurchaseOrder','receivePartiel');
    }else{
      dispatch('putSelectedPurchaseOrder','confirm');
    }
  }
}

const detectSelectedPurchaseOrderStatus = function({state, dispatch}){
  dispatch('putSelectedPurchaseOrder','set_in_correction')
}

const buildHistoricActivities = function ({commit, state}, status_logs){
  let activities = [];

  _.forEach(status_logs, log=>{
      let activity = {};

      if(log.status.code=="DRAFT")activity.type='primary';
      if(log.status.code=="ISSUED")activity.type='info';
      if(log.status.code=="PARTIAL_RECEIVED" || log.status.code=="BILLED")activity.type='warning';
      if(log.status.code=="RECEIVED")activity.type='success';
      if(log.status.code=="CANCELLED")activity.type='danger';

      if(log.status.code=="DRAFT")activity.icon='el-icon-star-on';
      if(log.status.code=="ISSUED")activity.icon='el-icon-postcard';
      if(log.status.code=="PARTIAL_RECEIVED")activity.icon='el-icon-s-claim';
      if(log.status.code=="RECEIVED")activity.icon='el-icon-circle-check';
      if(log.status.code=="CANCELLED")activity.icon='el-icon-circle-close';
      if(log.status.code=="BILLED")activity.icon='el-icon-bank-card';

      if(log.status.code=="DRAFT")activity.color='#5f8fdf';
      if(log.status.code=="RECEIVED")activity.color='#13ce66';
      if(log.status.code=="CANCELLED")activity.color='#ec205f';

      if(log.status.code=="DRAFT")activity.icon='large';
      if(log.status.code=="CANCELLED")activity.size='large';

      activity.content='purchase_orders.historic.'+log.status.code;

      activity.timestamp = log.created_at;
      activities.push(activity);
  })
  // console.log("Activities :", activities);
  commit('SET_PURCHASE_ORDER_HISTORIC_ACTIVITIES', activities);

}

const changeMode = function({commit}, mode){
  commit('SET_MODE',mode);
}

const setStatusFilters = function({commit, dispatch}, statusFilter){
  commit('SET_STATUS_FILTER', statusFilter);
  dispatch('invalidatePurchaseOrdersList');
  dispatch('fetchSearchedPurchaseOrders');
}

const setDateFilters = function({commit, dispatch}, dateFilter){
  commit('SET_DATE_FILTER', dateFilter);
  commit('SET_YEAR_FILTER', null);
  dispatch('invalidatePurchaseOrdersList');
  dispatch('fetchSearchedPurchaseOrders');
}

const setYearFilters = function({commit, dispatch}, yearFilter){
  commit('SET_YEAR_FILTER', yearFilter);
  commit('SET_DATE_FILTER', null);
  dispatch('invalidatePurchaseOrdersList');
  dispatch('fetchSearchedPurchaseOrders');
}

const setAvailabilityDateFilters = function({commit, dispatch}, availabilityDateFilter){
  commit('SET_AVAILABILITY_DATE_FILTER', availabilityDateFilter);
  commit('SET_AVAILABILITY_YEAR_FILTER', null);
  dispatch('invalidatePurchaseOrdersList');
  dispatch('fetchSearchedPurchaseOrders');
}

const setAvailabilityYearFilters = function({commit, dispatch}, availabilityYearFilter){
  commit('SET_AVAILABILITY_YEAR_FILTER', availabilityYearFilter);
  commit('SET_AVAILABILITY_DATE_FILTER', null);
  dispatch('invalidatePurchaseOrdersList');
  dispatch('fetchSearchedPurchaseOrders');
}

const resetFilters = function({commit, dispatch}){
  commit('RESET_FILTERS');
  dispatch('invalidatePurchaseOrdersList');
  dispatch('fetchSearchedPurchaseOrders');
}



export default {
  refreshSelectedPurchaseOrder,
  fetchSearchedPurchaseOrders,
  fetchNextPurchaseOrdersPage,
  initPurchaseOrders,
  setOrderBy,
  setSortIcon,
  setSearchTerms,
  changePage,
  setSelectedPurchaseOrder,
  putSelectedPurchaseOrder,
  updateSelectedPurchaseOrder,
  buildHistoricActivities,
  deleteSelectedPurchaseOrder,
  invalidAndUpdateSelectedPurchaseOrder,
  setItemInCorrection,
  changeMode,
  invalidatePurchaseOrdersList,
  setStatusFilters,
  setDateFilters,
  resetFilters,
  setYearFilters,
  setAvailabilityDateFilters,
  setAvailabilityYearFilters,
  setLoadingSelectedPurchaseOrder
};
